export enum DiffLabel {
    Negative = 'negative',
    Positive = 'positive',
    Same = 'same'
}
